class Vaccine {
    public Id: number;
    public NameFr: string;
    public NameEn: string;
    public NameESMX: string;
    public ImmunogenTypeFr: string;
    public ImmunogenTypeEn: string;
    public ImmunogenTypeESMX: string;
    public Manufacturer: string;
    public PreferredRoute: string;
    public DefaultDosage: number;
    public DefautlDosageUnit: string;

    public Active: boolean;

    public constructor(init?: Partial<Vaccine>) {
        Object.assign(this, init);
    }

    public static GetLocalizedName(r: Vaccine): string {
        if (sessionStore.userLanguageCode == "es-MX")
            return r.NameESMX;
        else if (sessionStore.userLanguageCode == "fr")
            return r.NameFr;
        else
            return r.NameEn;
    }

    public static GetLocalizedImmunogen(r: Vaccine): string {
        if (sessionStore.userLanguageCode == "es-MX")
            return r.ImmunogenTypeESMX;
        else if (sessionStore.userLanguageCode == "fr")
            return r.ImmunogenTypeFr;
        else
            return r.ImmunogenTypeEn;
    }
}

export { Vaccine };
